var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.629,
    height: 360.861,
    viewBox: "0 0 391.629 360.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filing",
    transform: "translate(-39.727 -89.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7333",
    "data-name": "Group 7333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7332",
    "data-name": "Group 7332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7328",
    "data-name": "Group 7328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M60.118,270.517a10.2,10.2,0,0,0-5.547,10.449,33.491,33.491,0,0,1,12.668-2.712",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7329",
    "data-name": "Group 7329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M57.36,272.527c-2.033,1.9,2.349-3.1,4.135-3.659a10.914,10.914,0,0,1,5.548.23c8.4,1.826,17.016,3.743,24.164,8.512,7.436,4.961,12.623,12.565,17.62,19.976a10.628,10.628,0,0,1,2.081,4.462c.2,1.645-.607,3.542-2.2,4a5.312,5.312,0,0,1-2.4-.061l-11.754-2.115c-5.358-.964-10.945-2.027-15.252-5.357-4.94-3.819-7.372-9.964-9.583-15.8-1.694-4.473-6.052-6.812-8.486-10.929C61.234,271.784,59.508,270.517,57.36,272.527Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7331",
    "data-name": "Group 7331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7330",
    "data-name": "Group 7330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M131.556,317.759a5.622,5.622,0,0,1-.8-.366l-2.237-1.142c-1.936-1.007-4.731-2.473-8.13-4.393a127.4,127.4,0,0,1-11.59-7.333c-2.1-1.509-4.239-3.181-6.351-5.042s-4.177-3.9-6.493-5.744a28.024,28.024,0,0,0-3.6-2.464,23.277,23.277,0,0,0-3.871-1.7c-1.317-.467-2.636-.9-3.881-1.47a14.668,14.668,0,0,1-3.39-2.149,28.018,28.018,0,0,1-4.777-5.6c-1.3-1.893-2.442-3.7-3.629-5.231a17.774,17.774,0,0,0-6.94-5.825,12.385,12.385,0,0,0-3.257-.8,5.405,5.405,0,0,1,.879.018,9.828,9.828,0,0,1,2.453.6,17.566,17.566,0,0,1,7.155,5.787c1.221,1.538,2.382,3.338,3.693,5.212a27.925,27.925,0,0,0,4.732,5.478,14.211,14.211,0,0,0,3.287,2.063c1.213.551,2.519.975,3.846,1.442a23.7,23.7,0,0,1,3.955,1.733,28.507,28.507,0,0,1,3.668,2.508c2.346,1.864,4.412,3.918,6.506,5.77s4.217,3.523,6.3,5.036a135.795,135.795,0,0,0,11.491,7.4c3.37,1.957,6.137,3.472,8.042,4.533l2.191,1.228A5.492,5.492,0,0,1,131.556,317.759Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7335",
    "data-name": "Group 7335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7334",
    "data-name": "Group 7334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M215.208,205.7s.292-.022.866-.033l2.555-.031,9.924-.059-.123.123c-.026-17.946-.077-53.839-.137-95.132,0-4.847,0-9.62,0-14.255l.258.258-85.792-.158.1-.1c-.021,2.706-.037,4.811-.048,6.261q-.017,1.049-.026,1.625c-.009.366-.026.553-.026.553s-.018-.187-.027-.553q-.009-.577-.026-1.625c-.011-1.45-.027-3.555-.048-6.261v-.1h.1l85.792-.158h.259v.259c0,4.635,0,9.408,0,14.255-.06,41.293-.111,77.186-.137,95.132v.124h-.124l-9.924-.058-2.555-.032C215.5,205.724,215.208,205.7,215.208,205.7Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7337",
    "data-name": "Group 7337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7336",
    "data-name": "Group 7336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M230.545,198.7s.292-.022.866-.033l2.555-.032,9.924-.059-.123.124c-.026-17.946-.077-53.84-.137-95.132,0-4.847,0-9.62,0-14.256l.258.258L158.1,89.41l.1-.1c-.021,2.707-.037,4.812-.048,6.262-.011.7-.02,1.239-.026,1.625-.009.366-.026.553-.026.553s-.018-.187-.027-.553c-.006-.386-.015-.926-.026-1.625-.011-1.45-.027-3.555-.048-6.262v-.1h.1l85.792-.157h.259v.258c0,4.636,0,9.409,0,14.256-.06,41.292-.111,77.186-.137,95.132v.124h-.124l-9.924-.059-2.555-.031C230.837,198.719,230.545,198.7,230.545,198.7Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7343",
    "data-name": "Group 7343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7338",
    "data-name": "Group 7338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M416.843,117.718H351.162a14.514,14.514,0,0,0-14.514,14.513v28.517a14.514,14.514,0,0,0,14.514,14.513h1.805v11.3l11.3-11.3h52.574a14.513,14.513,0,0,0,14.513-14.513V132.231A14.513,14.513,0,0,0,416.843,117.718Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7342",
    "data-name": "Group 7342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7339",
    "data-name": "Group 7339"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1059",
    "data-name": "Ellipse 1059",
    cx: 3.223,
    cy: 3.223,
    r: 3.223,
    transform: "translate(365.907 145.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5495",
    "data-name": "Path 5495",
    d: "M369.13,152.139a3.723,3.723,0,1,1,3.723-3.723A3.728,3.728,0,0,1,369.13,152.139Zm0-6.446a2.723,2.723,0,1,0,2.723,2.723A2.726,2.726,0,0,0,369.13,145.693Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7340",
    "data-name": "Group 7340"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1060",
    "data-name": "Ellipse 1060",
    cx: 3.223,
    cy: 3.223,
    r: 3.223,
    transform: "translate(380.779 145.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M384,151.994a3.723,3.723,0,1,1,3.722-3.723A3.728,3.728,0,0,1,384,151.994Zm0-6.446a2.723,2.723,0,1,0,2.722,2.723A2.726,2.726,0,0,0,384,145.548Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7341",
    "data-name": "Group 7341"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1061",
    "data-name": "Ellipse 1061",
    cx: 3.223,
    cy: 3.223,
    r: 3.223,
    transform: "translate(395.651 145.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M398.875,151.994a3.723,3.723,0,1,1,3.722-3.723A3.728,3.728,0,0,1,398.875,151.994Zm0-6.446a2.723,2.723,0,1,0,2.722,2.723A2.726,2.726,0,0,0,398.875,145.548Z",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7344",
    "data-name": "Group 7344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M88.012,217.176c3.305,4.159,8.911,6.632,8.3,9.935-.547,2.94-3.169,11.833-2.93,14.814.311,3.876,3.873,6.571,7.154,8.657s6.928,4.547,7.6,8.377c.578,3.313-1.317,6.7-.672,10,.816,4.178,5.21,6.495,9.142,8.127q10.073,4.181,20.455,7.551a20.741,20.741,0,0,0-6.348-19.627c-2.535-2.249-5.689-3.927-7.488-6.8-2.148-3.426-1.9-7.754-2.18-11.788s-1.605-8.6-5.3-10.23c-2.06-.91-4.64-.783-6.26-2.348-2-1.929-1.391-5.2-1.995-7.906-.843-3.785-4.255-6.575-7.94-7.779s-7.653-1.1-11.528-.989",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7345",
    "data-name": "Group 7345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M147.451,293.922c-4.6-7.463-2.681-16.446,1.162-24.327s10.264-14.169,16.742-20.078c6.6-6.019,14.467-12.2,23.36-11.379-5.1,2.573-7.2,8.7-8.275,14.308s-1.77,11.689-5.537,15.986c-1.894,2.162-4.585,3.929-5.172,6.743-.532,2.546.872,5.235.2,7.748-1.091,4.077-6.756,5.23-8.514,9.067-.85,1.855-.667,4.137-1.861,5.792-1.513,2.1-4.732,2.278-7.035,1.1s-3.9-3.348-5.42-5.444",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7347",
    "data-name": "Group 7347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7346",
    "data-name": "Group 7346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M149.159,314.99a31.273,31.273,0,0,1-2.322-4.147c-1.337-2.758-2.969-6.881-4.873-12.007-.959-2.561-1.984-5.374-3.156-8.364a88.169,88.169,0,0,0-4.154-9.347,22.6,22.6,0,0,0-3.07-4.528,25.422,25.422,0,0,0-4.491-3.543c-1.639-1.073-3.374-2.083-5.028-3.3a17.9,17.9,0,0,1-4.42-4.4,11.817,11.817,0,0,1-1.885-5.944c-.155-2.05-.034-4.06-.194-5.995a11.391,11.391,0,0,0-1.623-5.364,6.168,6.168,0,0,0-1.932-1.858,12.84,12.84,0,0,0-2.456-1.088c-1.678-.586-3.483-1.076-4.8-2.34a6.428,6.428,0,0,1-1.687-4.723c-.022-1.63.175-3.175.125-4.647a11.967,11.967,0,0,0-.879-4.108,17.46,17.46,0,0,0-4.153-5.947,32.911,32.911,0,0,0-4.343-3.443c-1.265-.854-2.274-1.479-2.954-1.91L90.1,217.5a1.373,1.373,0,0,1-.254-.183,1.4,1.4,0,0,1,.281.137l.8.45c.7.4,1.725,1,3.012,1.831a31.646,31.646,0,0,1,4.431,3.4,17.6,17.6,0,0,1,4.294,6.019,12.288,12.288,0,0,1,.939,4.233c.061,1.513-.126,3.066-.094,4.652a5.993,5.993,0,0,0,1.575,4.4c1.2,1.149,2.929,1.632,4.634,2.215a13.24,13.24,0,0,1,2.554,1.124,6.665,6.665,0,0,1,2.089,2,11.847,11.847,0,0,1,1.719,5.6c.167,1.988.048,3.993.2,6a11.3,11.3,0,0,0,1.8,5.7,17.444,17.444,0,0,0,4.292,4.27c1.622,1.192,3.351,2.2,5,3.287a25.76,25.76,0,0,1,4.571,3.626,22.988,22.988,0,0,1,3.134,4.644,86.8,86.8,0,0,1,4.133,9.419c1.157,3,2.163,5.824,3.1,8.392,1.859,5.141,3.434,9.274,4.711,12.049.656,1.377,1.158,2.453,1.569,3.144l.436.8A1.405,1.405,0,0,1,149.159,314.99Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7349",
    "data-name": "Group 7349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7348",
    "data-name": "Group 7348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5501",
    "data-name": "Path 5501",
    d: "M188.5,238.035a5.72,5.72,0,0,1-.787.426c-.525.259-1.289.663-2.241,1.234a33.139,33.139,0,0,0-11.217,11,35.626,35.626,0,0,0-1.715,3.169c-.534,1.122-1.049,2.3-1.645,3.485a17.029,17.029,0,0,1-2.21,3.445,11.093,11.093,0,0,1-3.4,2.606,31.894,31.894,0,0,0-3.778,2.115,6.366,6.366,0,0,0-2.464,3.462c-.837,2.849-.383,5.941-1.353,8.753-.973,2.788-2.8,4.958-4.032,7.244a18.437,18.437,0,0,0-2.144,7.017,26.922,26.922,0,0,0,.133,6.448,55.706,55.706,0,0,0,2.23,9.125l.78,2.443a5.7,5.7,0,0,1,.244.861.749.749,0,0,1-.1-.205c-.067-.17-.146-.374-.244-.622-.207-.549-.507-1.36-.874-2.413a51.478,51.478,0,0,1-2.4-9.137,26.912,26.912,0,0,1-.2-6.545,18.771,18.771,0,0,1,2.153-7.2c1.257-2.34,3.052-4.51,3.969-7.177s.47-5.724,1.339-8.742A6.891,6.891,0,0,1,161.2,265.1a32.072,32.072,0,0,1,3.843-2.146,10.591,10.591,0,0,0,3.263-2.482,16.64,16.64,0,0,0,2.159-3.337c.593-1.165,1.114-2.338,1.659-3.465a35.518,35.518,0,0,1,1.761-3.2,33.155,33.155,0,0,1,4.028-5.157,31.892,31.892,0,0,1,7.454-5.795,23.9,23.9,0,0,1,2.3-1.153A5.7,5.7,0,0,1,188.5,238.035Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7350",
    "data-name": "Group 7350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5502",
    "data-name": "Path 5502",
    d: "M300.4,273.193c9.384-.812,18.916-1.623,28.24-.5s18.576,4.462,23.629,10.3c4.255,4.918,5.087,10.96,5.808,16.756q3.088,24.822,6.178,49.643c.525,4.217,1.027,8.584-.858,12.587-4.121,8.749-19.294,12.877-31.381,10.145a37.226,37.226,0,0,1-25.15-19.457c-4.311-8.7-4.861-18.116-5.366-27.362l-2.75-50.3,1.223-.795",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7351",
    "data-name": "Group 7351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M39.727,358.976l2.913,10.239,277.881,80.7L416.1,386.833v-8.6Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5504",
    "data-name": "Path 5504",
    d: "M139.412,312.681,416.1,378.23,320.521,440.6,39.727,358.976Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5505",
    "data-name": "Path 5505",
    d: "M285.4,368.961,232.474,394.54l-97.023-26.461,47.629-26.02Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5506",
    "data-name": "Path 5506",
    d: "M227.042,367.879l14.051,4.641,13.007-7.073L232.45,358.5l-12.644,6.553Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5507",
    "data-name": "Path 5507",
    d: "M123.1,296.635c.441,1.764,12.348,71.444,12.348,71.444l97.023,26.461-12.79-74.531Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5508",
    "data-name": "Path 5508",
    d: "M225.413,353.39c.141-.024,1.837,9.169,3.787,20.53s3.416,20.6,3.274,20.62-1.837-9.166-3.788-20.532S225.271,353.415,225.413,353.39Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M180.386,343.747c1.18,3.048.011,6.343-2.613,7.359s-5.707-.631-6.888-3.678-.01-6.342,2.613-7.359S179.205,340.7,180.386,343.747Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7445",
    "data-name": "Group 7445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M219.684,320.009c4.318-4.987,6.831-39.041,6.831-39.041l32.022,3.6h0s-4.6,49.812-19.231,55.789l-14.629,5.977",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M324.807,330.674s14.166,15.863,13.312,29.081L312.991,353.8l9.686-23.128",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M344.987,286.256c-.613-27.786-11.6-41.385-12.047-43.15a43.318,43.318,0,0,0-31.964-14.059l-29.829.483a69.49,69.49,0,0,0-22.091,6.425l-.736.214.006.154c-8.432,4.408-17.5,11.27-18.928,22.84l-3.6,22.526,20.736.987h0c-2.109,7.542-4.439,8.512-2.012,15.957l7.9,13.105c0,10.456-.7,4.127-3.913,26.788l80.126,18.982c4.646-4.579,1.11-16.984-11.294-39.569-1.854-3.374,7.758-37.375,7.758-37.375l17.931,6.281",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M329.744,374.367",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M251.2,274.114a9.479,9.479,0,0,1-.722,1.416c-.491.895-1.219,2.181-2.063,3.8-1.647,3.2-3.935,7.858-4.155,13.409a16.838,16.838,0,0,0,1.376,7.548,24.381,24.381,0,0,0,3.391,5.355c1.141,1.414,2.146,2.5,2.826,3.258a9.568,9.568,0,0,1,1.029,1.211,8.919,8.919,0,0,1-1.175-1.071c-.727-.718-1.775-1.766-2.964-3.164a23.487,23.487,0,0,1-3.545-5.393,16.967,16.967,0,0,1-1.459-7.763,24.973,24.973,0,0,1,1.615-7.734,43.05,43.05,0,0,1,2.736-5.831c.891-1.6,1.668-2.859,2.213-3.723A9.089,9.089,0,0,1,251.2,274.114Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M342.092,262.217a1.349,1.349,0,0,1-.229.2c-.16.124-.388.323-.713.55a12.461,12.461,0,0,1-3.11,1.509c-2.855.976-7.4,1.15-12.572-.409-2.582-.761-5.3-1.879-8.242-2.992a35.063,35.063,0,0,0-9.634-2.493,31.2,31.2,0,0,0-10.9,1.106,111.254,111.254,0,0,0-11.245,3.86,87.689,87.689,0,0,1-11.359,3.717,30.028,30.028,0,0,1-11.116.646,40.812,40.812,0,0,1-9.613-3.038c-2.9-1.232-5.57-2.44-8.1-3.266a27.192,27.192,0,0,0-7.027-1.371,17.314,17.314,0,0,0-5.365.542,14.353,14.353,0,0,0-4.161,1.971,1.3,1.3,0,0,1,.234-.2c.162-.121.4-.31.726-.532a12.75,12.75,0,0,1,3.145-1.437,17.146,17.146,0,0,1,5.433-.638,27.138,27.138,0,0,1,7.128,1.311c2.568.813,5.259,2.007,8.158,3.219a40.766,40.766,0,0,0,9.518,2.962,29.684,29.684,0,0,0,10.929-.669,88.456,88.456,0,0,0,11.289-3.706,109.954,109.954,0,0,1,11.3-3.868,31.539,31.539,0,0,1,11.077-1.089,35.166,35.166,0,0,1,9.742,2.567c2.941,1.134,5.644,2.266,8.2,3.043,5.1,1.584,9.575,1.469,12.4.567A14.138,14.138,0,0,0,342.092,262.217Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M317.493,311.9a3.438,3.438,0,0,1-.645.247l-1.882.6a50.514,50.514,0,0,1-7.079,1.7,26.15,26.15,0,0,1-5.038.295,24.19,24.19,0,0,1-5.709-1.006c-3.931-1.149-7.912-3.237-12.261-4.889a44.965,44.965,0,0,0-6.52-1.87,48.112,48.112,0,0,0-6.271-.793,44.869,44.869,0,0,0-10.67.729,44.092,44.092,0,0,0-6.969,1.924c-.813.269-1.414.555-1.84.706a3.49,3.49,0,0,1-.654.223,3.418,3.418,0,0,1,.611-.32c.414-.181,1.005-.5,1.811-.8a39.667,39.667,0,0,1,6.97-2.1,43.673,43.673,0,0,1,10.765-.847,47.464,47.464,0,0,1,6.347.771,44.711,44.711,0,0,1,6.6,1.883c4.4,1.672,8.351,3.762,12.217,4.918a24.186,24.186,0,0,0,5.593,1.034,26.377,26.377,0,0,0,4.964-.229,57.94,57.94,0,0,0,7.075-1.525l1.908-.508A3.28,3.28,0,0,1,317.493,311.9Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M281.164,341.245a5.887,5.887,0,0,1-1.334-.143,30.783,30.783,0,0,1-3.557-.843c-2.982-.822-6.9-2.519-11.378-3.843a23.214,23.214,0,0,0-11.75-.64,17.771,17.771,0,0,0-4.519,1.94c-.01-.014.077-.1.255-.237a7.2,7.2,0,0,1,.809-.584,12.225,12.225,0,0,1,3.361-1.475c3-.894,7.442-.833,11.987.495s8.413,3.088,11.343,3.992c1.458.473,2.655.8,3.49,1A7.629,7.629,0,0,1,281.164,341.245Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M318.144,280.124s-13.06,28.785-1.672,47.608l5.338-1.993-4.47-7.8a8.619,8.619,0,0,1-.149-3.616c.66-4.1,1.929-10.788,3.627-17.536Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7434",
    "data-name": "Group 7434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M296.341,176.2c6.435,5.614,9.309,14.458,9.52,23s-.545,18.227-.341,27.139l13.056-.257c8.636.257,18.412-.649,26.674-1.288a8.031,8.031,0,0,0,3.954-1.013c1.9-1.289,2.326-3.86,2.585-6.142.407-3.591.8-7.3-.229-10.761s-3.886-6.649-7.491-6.9c-1.27-.09-2.6.172-3.784-.305a4.756,4.756,0,0,1-2.543-3.487c-.333-1.458-.283-2.977-.505-4.456a12.48,12.48,0,0,0-8.167-9.757c-2.677-.9-5.909-1.029-7.669-3.24-2.14-2.687-.737-6.576-.624-10.01a12.476,12.476,0,0,0-20.205-10.2",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7427",
    "data-name": "Group 7427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M286.236,245.407h0a15.293,15.293,0,0,1-15.279-14.642c-.28-6.575-.51-12.815-.51-12.815s-12.543-1.165-13.462-13.577-.527-41.066-.527-41.066h0a43.251,43.251,0,0,1,43.714,2.776l1.928,1.3-.571,62.867A15.294,15.294,0,0,1,286.236,245.407Z",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M261.959,186.854a1.807,1.807,0,1,0-2.556.033A1.806,1.806,0,0,0,261.959,186.854Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M257.539,183.052c.208.2,1.37-.81,3.08-.924,1.709-.139,3.006.694,3.182.462.086-.1-.131-.479-.7-.858a4.227,4.227,0,0,0-5,.369C257.6,182.559,257.439,182.963,257.539,183.052Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M277.33,184.115a1.807,1.807,0,1,0,2.518.438A1.807,1.807,0,0,0,277.33,184.115Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M276.2,183.434c.208.2,1.37-.81,3.079-.924,1.709-.139,3.007.694,3.183.462.086-.1-.132-.479-.7-.858a4.227,4.227,0,0,0-5,.369C276.263,182.941,276.1,183.345,276.2,183.434Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M270.133,196.725a8.287,8.287,0,0,0-2.8-.416c-.451-.021-.808-.1-.855-.339a2.424,2.424,0,0,1,.241-1.3c.37-1.159.745-2.331,1.138-3.56,1.563-5.068,2.622-9.239,2.365-9.318s-1.733,3.963-3.3,9.031l-1.066,3.582a2.86,2.86,0,0,0-.129,1.875,1.173,1.173,0,0,0,.815.667,2.862,2.862,0,0,0,.769.052A8.327,8.327,0,0,0,270.133,196.725Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M275.808,198.272c1.717-1.172-4.747,2.91-8.239,2.955a4.736,4.736,0,0,0,5.7,1.537C276.9,201.174,275.808,198.272,275.808,198.272Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M270.415,217.772a28.943,28.943,0,0,0,15.91-5.6s-3.276,9.175-15.74,8.821Z",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M301.252,192.946c-4.5,3.62-9.929-5.745-12.34-11.621s-3.157-12.368-3.507-18.774c-.115-2.1-.133-4.4,1.086-6.05,1.287-1.742,1.731.275,3.265-1.24,2.65-2.62.131-2.63,2.779-2.309,4.531.549,14.406,8.4,15.235,13.148s.159,9.634-.513,14.411l-.921,6.546a10.711,10.711,0,0,1-1.292,4.423c-.837,1.278-2.463,2.109-3.792,1.466",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5529",
    "data-name": "Path 5529",
    d: "M301.411,182.734a1.874,1.874,0,0,1,1.792-1.879c2.318-.064,6.109.856,6.465,7.252.509,9.137-8.28,6.857-8.31,6.6C301.334,194.5,301.387,186.285,301.411,182.734Z",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M303.371,191.112c.038-.031.165.1.441.211a1.6,1.6,0,0,0,1.191-.042c.946-.408,1.673-1.985,1.625-3.635a5.236,5.236,0,0,0-.572-2.254,1.839,1.839,0,0,0-1.265-1.155.811.811,0,0,0-.915.488c-.108.263-.04.442-.088.46-.024.025-.2-.142-.152-.523a1.02,1.02,0,0,1,.328-.593,1.209,1.209,0,0,1,.867-.282,2.243,2.243,0,0,1,1.742,1.325,5.41,5.41,0,0,1,.693,2.516c.044,1.844-.8,3.619-2.1,4.075a1.709,1.709,0,0,1-1.469-.161C303.4,191.332,303.34,191.13,303.371,191.112Z",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7426",
    "data-name": "Group 7426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M286.437,156.61a29.26,29.26,0,0,1-17.391,18.579,2.257,2.257,0,0,1-2.155.019c-.762-.6-.466-1.856.169-2.587s1.532-1.243,2-2.092l-4.65,2.633a7.457,7.457,0,0,1-2.4,1.011,2.535,2.535,0,0,1-2.384-.75,1.556,1.556,0,0,1,.319-2.272c-1.049,1.719-3.746,1.882-5.289.587A5.466,5.466,0,0,1,253.2,166.2a11.232,11.232,0,0,1,3.261-5c6.435-6.258,15.776-8.525,24.731-9.141a28.82,28.82,0,0,1,8.271.36c2.7.6,6.879.383,11.748,5.717",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7429",
    "data-name": "Group 7429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7428",
    "data-name": "Group 7428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M264.462,178.382c-.1.284-1.736-.077-3.747-.023-2.012.028-3.632.456-3.742.176-.122-.246,1.488-1.179,3.721-1.217C262.926,177.264,264.573,178.131,264.462,178.382Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7431",
    "data-name": "Group 7431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7430",
    "data-name": "Group 7430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M282.728,178.588c-.1.281-1.677-.064-3.619-.154-1.942-.11-3.543.071-3.616-.219-.08-.264,1.547-.936,3.67-.821S282.835,178.333,282.728,178.588Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7433",
    "data-name": "Group 7433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7432",
    "data-name": "Group 7432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M306.637,173.228a22,22,0,0,1,.7-2.559,10.628,10.628,0,0,0-3.958-11c-1.267-.984-2.224-1.372-2.166-1.528.031-.115,1.108.027,2.585.923a10.062,10.062,0,0,1,4.247,11.8C307.474,172.5,306.735,173.3,306.637,173.228Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7444",
    "data-name": "Group 7444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7435",
    "data-name": "Group 7435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M318.144,280.124l7.114,44.327-57.324,21.406,9.273,19.123,60.333-18.846a20.475,20.475,0,0,0,14.047-23.166l-7.7-42.844Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7443",
    "data-name": "Group 7443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5536",
    "data-name": "Path 5536",
    d: "M268.28,345.728s-10.671-3.4-15.787-4.706c-1.994-.508-10.533,4-16.431,7.741,0,0-8.123,4.816-7.466,6.3.723,1.633,3.719,1.3,8.5-.947,0,0-1.666,4.839,1.6,4.735,0,0-1.623,5.23,1.443,5.771s3.787-6.132,6.493-6.493,8.3-.721,8.3-.721,4.656,7.711,8.263,8.252,14.358-.68,14.358-.68Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7438",
    "data-name": "Group 7438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5537",
    "data-name": "Path 5537",
    d: "M246.683,347.847a47.258,47.258,0,0,1-8.381,5.285,47.262,47.262,0,0,1,8.381-5.285Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7440",
    "data-name": "Group 7440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7439",
    "data-name": "Group 7439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5538",
    "data-name": "Path 5538",
    d: "M247.6,350.82a29.661,29.661,0,0,1-4.916,2.556,29.648,29.648,0,0,1-5.136,2.083A58.964,58.964,0,0,1,247.6,350.82Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7442",
    "data-name": "Group 7442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7441",
    "data-name": "Group 7441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M245.942,358.028a23.5,23.5,0,0,1-6.914.948,23.51,23.51,0,0,1,6.914-.948Z",
    fill: "#eb996e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7484",
    "data-name": "Group 7484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7449",
    "data-name": "Group 7449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7446",
    "data-name": "Group 7446"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 85.793,
    height: 109.388,
    transform: "translate(128.826 103.971)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7448",
    "data-name": "Group 7448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7447",
    "data-name": "Group 7447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M214.619,213.359s-.009-.183-.014-.528-.007-.866-.013-1.534c-.007-1.359-.016-3.352-.028-5.944-.015-5.2-.036-12.786-.062-22.4-.029-19.219-.069-46.535-.117-78.979l.234.234-85.784.027h-.009l.26-.261c-.016,40.547-.032,78.2-.044,109.388l-.216-.216,62.248.112,17.378.056,4.581.024c1.039.008,1.586.024,1.586.024s-.516.016-1.54.024l-4.54.024-17.33.056-62.383.112h-.216v-.216c-.013-31.188-.028-68.841-.044-109.388v-.26h.27l85.784.027h.234v.233c-.048,32.506-.088,59.875-.116,79.131-.027,9.594-.048,17.164-.062,22.35-.013,2.571-.022,4.549-.028,5.9-.006.656-.011,1.157-.014,1.508S214.619,213.359,214.619,213.359Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7451",
    "data-name": "Group 7451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7450",
    "data-name": "Group 7450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M203.562,122.108c0,.288-7.239.521-16.166.521s-16.168-.233-16.168-.521,7.237-.521,16.168-.521S203.562,121.821,203.562,122.108Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7453",
    "data-name": "Group 7453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7452",
    "data-name": "Group 7452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M203.562,128.434c0,.288-7.239.521-16.166.521s-16.168-.233-16.168-.521,7.237-.52,16.168-.52S203.562,128.147,203.562,128.434Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7455",
    "data-name": "Group 7455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7454",
    "data-name": "Group 7454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5543",
    "data-name": "Path 5543",
    d: "M203.562,135.7c0,.287-7.239.52-16.166.52s-16.168-.233-16.168-.52,7.237-.521,16.168-.521S203.562,135.41,203.562,135.7Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7457",
    "data-name": "Group 7457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7456",
    "data-name": "Group 7456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5544",
    "data-name": "Path 5544",
    d: "M165.735,150.94c0,.288-6.4.521-14.287.521s-14.289-.233-14.289-.521,6.4-.521,14.289-.521S165.735,150.653,165.735,150.94Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7459",
    "data-name": "Group 7459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7458",
    "data-name": "Group 7458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5545",
    "data-name": "Path 5545",
    d: "M165.735,157.266c0,.288-6.4.521-14.287.521s-14.289-.233-14.289-.521,6.4-.52,14.289-.52S165.735,156.979,165.735,157.266Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7461",
    "data-name": "Group 7461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7460",
    "data-name": "Group 7460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5546",
    "data-name": "Path 5546",
    d: "M165.735,164.53c0,.288-6.4.521-14.287.521s-14.289-.233-14.289-.521,6.4-.521,14.289-.521S165.735,164.242,165.735,164.53Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7463",
    "data-name": "Group 7463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7462",
    "data-name": "Group 7462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5547",
    "data-name": "Path 5547",
    d: "M165.735,172.13c0,.288-6.4.521-14.287.521s-14.289-.233-14.289-.521,6.4-.521,14.289-.521S165.735,171.842,165.735,172.13Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7465",
    "data-name": "Group 7465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7464",
    "data-name": "Group 7464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5548",
    "data-name": "Path 5548",
    d: "M165.735,178.456c0,.288-6.4.521-14.287.521s-14.289-.233-14.289-.521,6.4-.521,14.289-.521S165.735,178.169,165.735,178.456Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7467",
    "data-name": "Group 7467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7466",
    "data-name": "Group 7466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5549",
    "data-name": "Path 5549",
    d: "M165.735,185.72c0,.287-6.4.52-14.287.52s-14.289-.233-14.289-.52,6.4-.521,14.289-.521S165.735,185.432,165.735,185.72Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7469",
    "data-name": "Group 7469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7468",
    "data-name": "Group 7468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5550",
    "data-name": "Path 5550",
    d: "M165.735,193.32c0,.287-6.4.52-14.287.52s-14.289-.233-14.289-.52,6.4-.521,14.289-.521S165.735,193.032,165.735,193.32Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7471",
    "data-name": "Group 7471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7470",
    "data-name": "Group 7470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5551",
    "data-name": "Path 5551",
    d: "M165.735,199.646c0,.288-6.4.521-14.287.521s-14.289-.233-14.289-.521,6.4-.521,14.289-.521S165.735,199.358,165.735,199.646Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7473",
    "data-name": "Group 7473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7472",
    "data-name": "Group 7472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5552",
    "data-name": "Path 5552",
    d: "M205.2,199.646c0,.288-6.966.521-15.557.521s-15.559-.233-15.559-.521,6.964-.521,15.559-.521S205.2,199.358,205.2,199.646Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7475",
    "data-name": "Group 7475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7474",
    "data-name": "Group 7474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5553",
    "data-name": "Path 5553",
    d: "M204.581,178.456c0,.288-6.966.521-15.557.521s-15.559-.233-15.559-.521,6.964-.521,15.559-.521S204.581,178.169,204.581,178.456Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7477",
    "data-name": "Group 7477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7476",
    "data-name": "Group 7476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5554",
    "data-name": "Path 5554",
    d: "M204.581,184.782c0,.288-6.966.521-15.557.521s-15.559-.233-15.559-.521,6.964-.52,15.559-.52S204.581,184.495,204.581,184.782Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7479",
    "data-name": "Group 7479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7478",
    "data-name": "Group 7478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5555",
    "data-name": "Path 5555",
    d: "M204.581,192.046c0,.287-6.966.52-15.557.52s-15.559-.233-15.559-.52,6.964-.521,15.559-.521S204.581,191.758,204.581,192.046Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7480",
    "data-name": "Group 7480"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 27.422,
    height: 20.621,
    transform: "translate(175.075 146.766)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7481",
    "data-name": "Group 7481",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5556",
    "data-name": "Path 5556",
    d: "M175.075,161.119l7.041-4.694,7.525,4.694,8.078-5.962,4.777,2.981v9.25H175.075Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7482",
    "data-name": "Group 7482",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5557",
    "data-name": "Path 5557",
    d: "M192.325,152.691a2.465,2.465,0,1,1-2.465-2.465A2.465,2.465,0,0,1,192.325,152.691Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7483",
    "data-name": "Group 7483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5558",
    "data-name": "Path 5558",
    d: "M157.8,121.282l.2,4.195h-.5a5.068,5.068,0,0,0-.4-1.583,2.656,2.656,0,0,0-1.088-1.128,3.8,3.8,0,0,0-1.788-.363h-2.52v13.668a3.666,3.666,0,0,0,.356,2.058,1.983,1.983,0,0,0,1.544.554h.62v.488h-7.586v-.488h.633a1.82,1.82,0,0,0,1.61-.686,4.007,4.007,0,0,0,.29-1.926V122.4h-2.151a6,6,0,0,0-1.781.185,2.442,2.442,0,0,0-1.174.963,3.9,3.9,0,0,0-.58,1.926h-.5l.212-4.195Z",
    fill: "#263238"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiling);
export default __webpack_public_path__ + "static/media/filing.5f78c23ad9c0b38959e3206570d0a63e.svg";
export { ForwardRef as ReactComponent };